import { render } from "./add_2.vue?vue&type=template&id=33e2af78&ts=true"
import script from "./add_2.vue?vue&type=script&lang=ts"
export * from "./add_2.vue?vue&type=script&lang=ts"

import "./add_2.vue?vue&type=style&index=0&id=33e2af78&lang=scss"

import exportComponent from "/home/quangphuc/s-tech/admin-nhaongay/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__